import takeRight from 'lodash/takeRight'

const ScrollDepthTracker = {
  stack: [],
  push(path, scrollDepth) {
    return this.stack.push({ path, scrollDepth })
  },

  getPrevious() {
    this.stack = takeRight(this.stack, 2)
    return this.stack[0]
  },
}

export default ScrollDepthTracker
